export default function () {
	return function (seconds) {
		if (seconds) {
			let roundedValue = Math.ceil(seconds / 60);
			if (roundedValue == 0) {
				return 1;
			} else {
				return roundedValue;
			}
		} else {
			return ' - ';
		}
	};
}
